/* Elyvon — scripts du thème (vanilla, sans dépendance) */
(function () {
  'use strict';

  /* Menu mobile */
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var menu = document.getElementById(btn.getAttribute('aria-controls'));
      if (!menu) return;
      var open = menu.hasAttribute('open');
      if (open) menu.removeAttribute('open'); else menu.setAttribute('open', '');
      btn.setAttribute('aria-expanded', String(!open));
    });
  });

  /* Sélecteurs de quantité (hero + panier) */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var minus = wrap.querySelector('[data-qminus]');
    var plus = wrap.querySelector('[data-qplus]');
    if (!input) return;
    var change = function (delta) {
      var v = parseInt(input.value, 10) || 1;
      v = Math.max(parseInt(input.min, 10) || 0, v + delta);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    if (minus) minus.addEventListener('click', function () { change(-1); });
    if (plus) plus.addEventListener('click', function () { change(1); });
  });

  /* Panier : soumission auto quand la quantité change */
  var cartForm = document.getElementById('CartForm');
  if (cartForm) {
    cartForm.querySelectorAll('input[name="updates[]"]').forEach(function (input) {
      input.addEventListener('change', function () { cartForm.submit(); });
    });
  }

  /* Sections produit (hero) */
  document.querySelectorAll('[data-product-section]').forEach(function (root) {
    /* Galerie */
    var main = root.querySelector('.main-image img');
    root.querySelectorAll('.thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('.thumb').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        if (main) { main.src = btn.dataset.src; if (btn.dataset.alt) main.alt = btn.dataset.alt; }
      });
    });

    /* Variantes : mise à jour prix / disponibilité */
    var select = root.querySelector('[data-variant-select]');
    var dataEl = root.querySelector('[data-variants-json]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var submit = root.querySelector('[data-submit]');
    var money = function (cents) {
      var fmt = root.dataset.moneyFormat || '{{amount_with_comma_separator}} €';
      var amount = (cents / 100).toFixed(2);
      var withComma = amount.replace('.', ',');
      var withDot = amount;
      return fmt
        .replace('{{amount_with_comma_separator}}', withComma)
        .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100).toString())
        .replace('{{amount_no_decimals}}', Math.round(cents / 100).toString())
        .replace('{{amount}}', withDot);
    };
    if (select && dataEl) {
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
      select.addEventListener('change', function () {
        var id = parseInt(select.value, 10);
        var v = variants.filter(function (x) { return x.id === id; })[0];
        if (!v) return;
        if (priceEl) priceEl.textContent = money(v.price);
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price); compareEl.hidden = false; }
          else compareEl.hidden = true;
        }
        if (submit) {
          submit.disabled = !v.available;
          submit.textContent = v.available ? submit.dataset.labelAdd : submit.dataset.labelSoldOut;
        }
        if (v.featured_image && main) main.src = v.featured_image.src;
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      });
    }

    /* Barre sticky */
    var sticky = root.querySelector('[data-sticky]');
    var hero = root.querySelector('.hero');
    if (sticky && hero && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('show', !entries[0].isIntersecting);
      }, { threshold: 0.05 }).observe(hero);
      var stickyBtn = sticky.querySelector('[data-sticky-submit]');
      var form = root.querySelector('form[action*="/cart/add"]');
      if (stickyBtn && form) {
        stickyBtn.addEventListener('click', function () {
          if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
        });
      }
    }
  });
})();
